export default __webpack_public_path__ + "static/media/propayout.0c42379e.png";